module.exports = __webpack_public_path__ + "static/img/3_10commitments_75percent.735ad45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/3_10commitments_75percent.jpg
// module id = 5fzM
// module chunks = 0